export const getToken = () => {
  return localStorage.getItem('COLA_TOKEN');
};

export const setToken = (token) => {
  return localStorage.setItem('COLA_TOKEN', token);
};

export const getUsername = () => {
  return localStorage.getItem('COLA_USERNAME');
};

export const setUsername = (name) => {
  return localStorage.setItem('COLA_USERNAME', name);
};
